import { useCallback } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import {
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import {
	buttonClassNames,
	formHeaderClassNames,
} from "@/shared/constants/customStyleSets";

export const CancelSuccessForm = () => {
	const navigate = useNavigate();

	const handleNavigate = useCallback(() => {
		navigate("/dashboard");
	}, [navigate]);

	return (
		<DialogContent data-testid="cancel-success-form">
			<DialogHeader>
				<DialogTitle className={formHeaderClassNames}>
					Your subscription was canceled!
				</DialogTitle>
			</DialogHeader>

			<DialogDescription className="text-[16px] text-center text-foreground">
				You have successfully canceled your subscription. <br />
				<br />
				You will continue to have premium access until the end of your current
				billing period. <br />
				<br />
				If you change your mind, you can resubscribe anytime to gain access to
				all premium features again.
			</DialogDescription>

			<DialogFooter className="sm:justify-center">
				<Button
					type="button"
					variant="secondary"
					className={buttonClassNames}
					onClick={handleNavigate}
				>
					Go to the app
				</Button>
			</DialogFooter>
		</DialogContent>
	);
};
